export const commonMapPoints = {
    augsburg: [10.8978, 48.3705] as [number, number],
};
